import { IonAvatar, IonIcon } from "@ionic/react";
import Avatar from "react-avatar";
import EmptyAvatar from "@/assets/empty_avatar.svg";
import { Button } from "@/components/Global/Button";
import { usePreferredHaptics } from "@/lib/hooks/usePreferredHaptics";
import { cameraIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { cx } from "@/lib/style/cva.config";

export function AuthAvatar({
	withEdit = false,
	parts,
	...props
}: React.ComponentProps<typeof IonAvatar> & {
	withEdit?: boolean;
	parts?: { img?: React.ComponentPropsWithoutRef<"img">; fullName?: string };
}) {
	const PreferredHaptics = usePreferredHaptics();

	return (
		<IonAvatar
			data-attr="auth.avatar"
			{...props}
			className={cx(
				"ion-rounded-full relative size-20",
				withEdit && "cursor-pointer",
				props.className,
			)}
			onClick={(event) => {
				if (!props?.onClick) {
					return;
				}

				PreferredHaptics.impact();
				props.onClick(event);
			}}
		>
			{parts?.img?.src ? (
				<img
					{...parts?.img}
					src={parts?.img?.src || EmptyAvatar}
					className={cx(
						"ph-no-capture",
						"absolute inset-0 -z-10 size-full rounded-full object-cover",
						parts?.img?.className,
					)}
				/>
			) : (
				<Avatar
					name={parts?.fullName || "?"}
					size="80"
					round
					className="absolute inset-0 -z-10 size-full"
				/>
			)}

			{withEdit && (
				<Button
					data-attr="auth.avatar.edit"
					variant="clear"
					className="text-brown-500 part-icon:m-0 part-native:size-9 part-native:min-h-0 part-native:rounded-full part-native:bg-white part-native:p-1 part-native:text-lg part-native:shadow-[0_4px_22px_0_--alpha(var(colors.black)/25%)] absolute -right-1 -bottom-1 size-9 min-h-0 opacity-100"
				>
					<IonIcon slot="icon-only" icon={cameraIcon} />
				</Button>
			)}
		</IonAvatar>
	);
}
